// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__31jkX","emails":"CreateEditClinics_emails__2vMt6","emailTagLabel":"CreateEditClinics_emailTagLabel__YMwWA"};